import { getViewData } from '../modules/view-data';

export default {
    /**
     * Provide the feature switch as a globally available plugin
     *
     * e.g.  this.$can('manage_vehicles_add')
     *       <my-component v-if="$can('manage_vehicles_add')"/>
     *
     * @param {Object} Vue
     */
    install(Vue) {
        Vue.prototype.$can = (tag) => getViewData(`features.${ tag }`, false);
    },
};
